type CachedImageRecord = {
  url: string
  promise: Promise<HTMLImageElement>
}

const globalImageResourceCache = new Map<string, CachedImageRecord>()

function normalizeUrl(url: string): string {
  return String(url || '').trim()
}

function loadImage(url: string): Promise<HTMLImageElement> {
  const target = normalizeUrl(url)
  return new Promise<HTMLImageElement>((resolve, reject) => {
    const image = new Image()
    image.decoding = 'async'
    image.crossOrigin = 'anonymous'
    image.onload = () => resolve(image)
    image.onerror = () => reject(new Error(`image load failed: ${target}`))
    image.src = target
  })
}

export function getCachedImageResource(url: string): Promise<HTMLImageElement> {
  const target = normalizeUrl(url)
  if (!target) {
    return Promise.reject(new Error('image url is empty'))
  }
  const cached = globalImageResourceCache.get(target)
  if (cached) return cached.promise

  const promise = loadImage(target).catch((error) => {
    globalImageResourceCache.delete(target)
    throw error
  })
  globalImageResourceCache.set(target, {
    url: target,
    promise,
  })
  return promise
}

export function primeCachedImageResources(urls: string[]): Promise<void> {
  return Promise.all(
    urls
      .map((url) => normalizeUrl(url))
      .map((url) => getCachedImageResource(url)),
  ).then(() => undefined)
}
